<template>
  <article class="basic">
    <slot />
  </article>
</template>

<script>
export default {};
</script>

<style lang="scss">
/*:: Basic
---------------------------------------- */
.basic {
  background: #f7f7f7;
  padding: 1.875rem 0;
  width: 100%;
  padding-bottom: 3.125rem;
  padding-top: 1.875rem;
}

.basic__title {
  margin-bottom: 2.5rem;
}
</style>
